import { render, staticRenderFns } from "./ProductStockInfo.vue?vue&type=template&id=418aaa95&scoped=true"
import script from "./ProductStockInfo.vue?vue&type=script&lang=ts"
export * from "./ProductStockInfo.vue?vue&type=script&lang=ts"
import style0 from "./ProductStockInfo.vue?vue&type=style&index=0&id=418aaa95&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418aaa95",
  null
  
)

export default component.exports